import { deepMerge } from '@/utils';

export default {
  data() {
    return {
      /* Modals */
      currentEditableItem: {},
      currentClonableItem: {},
    };
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {

  },
  methods: {
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);
      this.searchParams = deepMerge(this.searchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },

  },
};
